// Guarda o destino pretendido antes do login SSO.
// O login usa redirect completo para a Microsoft, então o state do React Router
// se perde na volta; sessionStorage sobrevive ao round trip na mesma aba.

const STORAGE_KEY = 'gmud:postLoginRedirect';

interface PostLoginRedirect {
  path: string;
  fromEmail: boolean;
}

// Aceita apenas caminhos internos (evita redirecionamento para sites externos)
export const isSafeInternalPath = (path: unknown): path is string =>
  typeof path === 'string' &&
  path.startsWith('/') &&
  !path.startsWith('//') &&
  !path.startsWith('/\\') &&
  !path.startsWith('/login') &&
  !path.startsWith('/email-redirect');

export const savePostLoginRedirect = (path: string, fromEmail = false): void => {
  if (!isSafeInternalPath(path)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ path, fromEmail }));
  } catch {
    // sessionStorage indisponível: segue sem guardar o destino
  }
};

export const peekPostLoginRedirect = (): PostLoginRedirect | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PostLoginRedirect>;
    if (!isSafeInternalPath(parsed.path)) return null;
    return { path: parsed.path, fromEmail: Boolean(parsed.fromEmail) };
  } catch {
    return null;
  }
};

export const consumePostLoginRedirect = (): string | null => {
  const redirect = peekPostLoginRedirect();
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignora
  }
  return redirect ? redirect.path : null;
};
